window.OKJS = window.OKJS || {};
(function(OKJS) {
    var isInitted = false;

    OKJS.Socialmedia = {
        shareFacebook: function(url, title, description, image) {
            var properties = {
                'og:url': url,
                'og:description': description,
                'og:image': image,
                'og:locale' : 'da_DK',
                "og:title" : title
            };

            FB.ui({
                    method: 'share_open_graph',
                    action_type: 'og.shares',
                    action_properties: JSON.stringify({
                        object: properties
                    })
                },
                function(response) {});
        },
        registerFacebookButton: function(id) {
            var btn = document.getElementById(id);

            if (btn) {
            btn.addEventListener('click', 
                function(e) {
                    var dataset = e.currentTarget.dataset;
                    OKJS.Socialmedia.shareFacebook(dataset.url, dataset.title, dataset.description, dataset.image, dataset.video);
                });
            }
        },

        initFacebook: function(appId) {
            if (isInitted) {
                return;
            }
            window.fbAsyncInit = function() {
                FB.init({
                    appId: appId, // App ID
                    status: true, // check login status
                    cookie: true, // enable cookies to allow the
                    // server to access the session
                    xfbml: true, // parse page for xfbml or html5
                    // social plugins like login button below
                    version: 'v2.7' // Specify an API version
                });
                isInitted = true;
            };

            // Load the SDK Asynchronously
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

        }
    }

})(window.OKJS);
